import React from 'react'

const PaymentGateway = () => {
  return (
    <div>Payment Gateway</div>
  )
}

export default PaymentGateway;